export default __webpack_public_path__ + "static/media/5cea11686ff9bb0189cbb3e8070488b7.geojson";